

















































































































































































































import i18n from 'vue-i18n';
import axios from 'axios';
import { uniq, map, get, uniqueId, isArray, cloneDeep } from 'lodash';
import CoPost from '@/components/Organisms/co-post/CoPost.vue';
import CoPostEditor from '@/components/Organisms/co-post-editor/coPostEditor.vue';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoInput from '@/components/Molecules/co-input/CoInput.vue';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import JSConfetti from 'js-confetti';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import CoThumbnail from '@/components/Molecules/co-thumbnail/CoThumbnail.vue';
import CoStreamUpdatesIndicator from '@/components/Organisms/co-stream-updates-indicator/CoStreamUpdatesIndicator.vue';

import EventBus from '../../../../eventBus';

// eslint-disable-next-line import/no-extraneous-dependencies

const jsConfetti = new JSConfetti();
const POST_CREATION_NUDGING_FLAG = 'frontend.nudging.postcreation';
const POST_NUDGE_THRESHOLD_SECONDS = 14 * 24 * 60 * 60;
const POST_SUGGESTION_TYPES = ['question', 'poll', 'meme', 'guide', 'spotlight', 'challenge', 'ama'];

type DashboardFeedEntry = {
    object: Record<string, any>;
    type?: string;
    space?: Record<string, any>;
    wasUpdated?: boolean;
    streamUpdateHandled?: boolean;
    pendingStreamIndicatorEligible?: boolean;
};

export default {
    name: 'CoFeed',
    components: {
        CoPost,
        CoPostEditor,
        CoButton,
        CoInput,
        CoCard,
        CoHeadline,
        CoText,
        CoRoundButton,
        CoThumbnail,
        CoStreamUpdatesIndicator,
    },
    i18n: {
        messages: {
            en: {
                letscelebrate: "Let's celebrate!",
                whatyourcommunityisabout: 'Start by explaining what this community is about.',
                createfirstpost: 'Create your first post',
            },
            de: {
                letscelebrate: 'Lass uns feiern!',
                whatyourcommunityisabout: 'Starte am besten damit zu erklären, was in deiner Community wichtig ist.',
                createfirstpost: 'Erstelle deinen ersten Post',
            },
        },
    },
    data() {
        return {
            pinnedPosts: [],
            feedBank: [],
            feed: [],
            feedNextPage: null,
            loading: true,
            newPost: null,
            isMarketOn: this.$store.state.space.MarkeplaceOn,
            circlesOn: this.$store.state.circlesOn,
            nextParams: null,
            focusPostID: this.getRouteFocusPostID(),
            lastMissingFocusPostID: null,
            warningContentVisible: true,
            errorContentVisible: true,
            postToEdit: null,
            postingHistoryEntries: null,
            postingHistoryLoading: false,
            postingHistoryRequestID: 0,
            postCreationNudgingEnabled: this.$unleash.isEnabled(POST_CREATION_NUDGING_FLAG),
            // Keep the suggested format stable for this feed visit.
            postSuggestionIndex: Math.floor(Math.random() * POST_SUGGESTION_TYPES.length),
            pendingStreamPostIDs: [] as string[],
            pendingStreamPostIcon: 'chevron-up',
        };
    },
    computed: {
        canPost() {
            return this.$store.state.permissions && this.$store.state.permissions['feed.post'] === true;
        },
        asAdmin() {
            if (
                this.$store &&
                this.$store.state &&
                this.$store.state.me &&
                this.$store.state.me.Permissions &&
                this.$store.state.me.Permissions.includes('space_admin')
            ) {
                return true;
            }
            return false;
        },
        feedPostsToShow() {
            if (!this.feed || this.feed.length < 1) return [];
            // filter out pinned posts from feed
            const feed = this.feed.filter((post) => post.object.PinStatus !== 1);
            return feed;
        },
        postSuggestionKey() {
            const suggestionType = POST_SUGGESTION_TYPES[this.postSuggestionIndex] || POST_SUGGESTION_TYPES[0];
            return `communityFeed.postNudge.suggestions.${suggestionType}`;
        },
        postNudgeDismissed() {
            const userID = get(this, '$store.state.me.ID', null);
            const dismissals = get(this, '$store.state.postCreationNudgeDismissals', {});
            const dismissedAt = Number(dismissals[String(userID)] || 0);
            const dismissalThreshold = Math.floor(Date.now() / 1000) - POST_NUDGE_THRESHOLD_SECONDS;
            return dismissedAt > dismissalThreshold;
        },
        postNudge() {
            if (
                !this.canPost ||
                this.postNudgeDismissed ||
                !this.postCreationNudgingEnabled ||
                !get(this, '$store.state.me.ID', null) ||
                this.postingHistoryLoading ||
                !Array.isArray(this.postingHistoryEntries)
            ) {
                return null;
            }

            // The profile feed contains mixed public activity, so only authored posts affect eligibility.
            const posts = this.postingHistoryEntries.filter(
                (entry) => String(get(entry, 'type', '')).toLowerCase() === 'post'
            );
            if (posts.length > 0) {
                const createdAtValues = posts.map((entry) => Number(get(entry, 'object.CreatedAt', NaN)));
                if (createdAtValues.some((createdAt) => !Number.isFinite(createdAt) || createdAt <= 0)) return null;

                const latestPostCreatedAt = Math.max(...createdAtValues);
                const threshold = Math.floor(Date.now() / 1000) - POST_NUDGE_THRESHOLD_SECONDS;
                if (latestPostCreatedAt >= threshold) {
                    return null;
                }
            }

            return true;
        },
    },
    destroyed() {
        this.postingHistoryRequestID += 1;
        window.removeEventListener('scroll', this.scroll);
        window.removeEventListener('scroll', this.handlePendingStreamPostScroll);
        EventBus.$off('POST_CREATE', this.handleRealtimePostCreated);
        this.$unleash.off('update', this.updatePostCreationNudgingFlag);
    },
    async mounted() {
        this.$unleash.on('update', this.updatePostCreationNudgingFlag);
        this.scroll();
        this.loading = true;
        this.feed = [];
        this.feedNextPage = null;
        this.getPinnedPosts();
        this.getFeed();
        window.addEventListener('scroll', this.handlePendingStreamPostScroll, { passive: true });
        EventBus.$on('POST_CREATE', this.handleRealtimePostCreated);

        if (this.$route.query.focuspostid || this.$route.query.postpin) {
            this.focusPostID = this.getRouteFocusPostID();
        }
    },
    watch: {
        '$store.state.me.ID': {
            handler(userID, previousUserID) {
                if (userID && userID !== previousUserID) {
                    this.getPostingHistory();
                } else if (!userID && !get(this, '$store.getters.isAuthenticated', false)) {
                    // Unauthenticated feed access must never show the nudge or wait on private history.
                    this.postingHistoryRequestID += 1;
                    this.postingHistoryLoading = false;
                    this.postingHistoryEntries = null;
                }
            },
            immediate: true,
        },
        '$route.query.focuspostid': {
            handler(to, from) {
                this.focusPostID = this.getRouteFocusPostID();
                this.ensureFocusPostInFeed();
            },
            immediate: true,
        },
        '$route.query.postpin': {
            handler(to, from) {
                this.focusPostID = this.getRouteFocusPostID();
                this.ensureFocusPostInFeed();
            },
            immediate: true,
        },
    },
    methods: {
        async fetchFeedAuthors(authorIDs) {
            const ids = uniq(authorIDs.filter(Boolean));
            if (!ids.length) return [];

            const response = await axios({
                method: 'POST',
                url: '/user/listbyids',
                data: { IDS: map(ids, (id) => ({ ID: id })) },
                withCredentials: true,
                headers: { 'Content-Type': 'application/json' },
            });
            return map(get(response, 'data.Users', []), (user) => ({
                ID: get(user, 'ID'),
                Name: get(user, 'Profile.Name'),
                Slug: get(user, 'Slug'),
                ImageURL: get(user, 'Profile.ImageURL'),
                Bio: get(user, 'Profile.Bio'),
            }));
        },
        async handleRealtimePostCreated(post) {
            try {
                if (!post || typeof post !== 'object') return;
                const entry = { object: cloneDeep(post), type: 'post' } as DashboardFeedEntry;
                if (!entry.object || typeof entry.object !== 'object') return;

                // Child posts belong in the community feed only when their feed display setting includes it.
                const hasParent = Boolean(entry.object.Parent || entry.object.ParentID || entry.object.ParentType);
                if (hasParent && ![0, 2].includes(entry.object.FeedDisplay)) return;

                entry.type = entry.type || 'post';
                entry.space = entry.space || get(this, '$store.state.space', {});
                const authorID = entry.object.AuthorID || entry.object.CreatedBy || entry.object.UserID;
                if (!entry.object.Author && authorID) {
                    const knownEntry = [...this.feed, ...this.feedBank].find(
                        (candidate) =>
                            get(candidate, 'object.AuthorID') === authorID ||
                            get(candidate, 'object.CreatedBy') === authorID ||
                            get(candidate, 'object.UserID') === authorID
                    );
                    entry.object.Author = get(knownEntry, 'object.Author', null);
                    if (!entry.object.Author) {
                        const [author] = await this.fetchFeedAuthors([authorID]);
                        if (author) entry.object.Author = author;
                    }
                }

                this.normalizeFeedEntry(entry);
                const entryID = get(entry, 'object.ID', '').toString();
                if (!entryID) return;
                const existingFeedIndex = this.feed.findIndex(
                    (candidate) => get(candidate, 'object.ID', '').toString() === entryID
                );
                const existingBankIndex = this.feedBank.findIndex(
                    (candidate) => get(candidate, 'object.ID', '').toString() === entryID
                );

                if (existingFeedIndex > -1) {
                    this.feed.splice(existingFeedIndex, 1, {
                        ...entry,
                        wasUpdated: this.feed[existingFeedIndex]?.wasUpdated || false,
                        streamUpdateHandled: this.feed[existingFeedIndex]?.streamUpdateHandled || false,
                        pendingStreamIndicatorEligible:
                            this.feed[existingFeedIndex]?.pendingStreamIndicatorEligible || false,
                    });
                } else if (existingBankIndex > -1) {
                    this.feedBank.splice(existingBankIndex, 1, entry);
                } else {
                    entry.wasUpdated = true;
                    entry.streamUpdateHandled = false;
                    entry.pendingStreamIndicatorEligible = true;
                    this.feed.unshift(entry);
                    // App owns the browser-title indicator shared by all realtime feeds.
                    EventBus.$emit('TAB_ATTENTION');
                }

                this.syncFeedOrder();
            } catch (error) {
                console.error('Failed to process realtime post_create message', error);
            }
        },
        handlePostUpdated(post) {
            if (post.pendingStreamIndicatorEligible || post.streamUpdateHandled !== undefined) {
                this.handleStreamPostUpdated(post);
                return;
            }
            this.scrollRefIntoView(`post${post.object.ID}`);
        },
        handleStreamPostUpdated(post) {
            if (post.streamUpdateHandled) return;

            this.$set(post, 'streamUpdateHandled', true);
            if (!post.pendingStreamIndicatorEligible) return;

            this.$set(post, 'pendingStreamIndicatorEligible', false);
            const postID = get(post, 'object.ID', '').toString();
            if (!postID || this.pendingStreamPostIDs.includes(postID) || this.isStreamPostVisible(postID)) return;

            // Keep the highlight pending until the member reveals the new post.
            this.$set(post, 'wasUpdated', false);
            this.pendingStreamPostIDs.push(postID);
            this.updatePendingStreamPostIcon();
        },
        isStreamPostVisible(postID: string) {
            const refEl = this.$refs[`post${postID}`];
            const postComponent = Array.isArray(refEl) ? refEl[0] : refEl;
            const postElement = postComponent?.$el || postComponent;
            if (!postElement?.getBoundingClientRect) return false;

            const { top, bottom } = postElement.getBoundingClientRect();
            return top < window.innerHeight && bottom > 0;
        },
        handlePendingStreamPostScroll() {
            const visiblePostID = this.pendingStreamPostIDs.find((postID) => this.isStreamPostVisible(postID));
            if (!visiblePostID) {
                this.updatePendingStreamPostIcon();
                return;
            }

            const visiblePost = this.feed.find((entry) => get(entry, 'object.ID', '').toString() === visiblePostID);
            if (visiblePost) this.$set(visiblePost, 'wasUpdated', true);
            this.removePendingStreamPostID(visiblePostID);
        },
        updatePendingStreamPostIcon() {
            const targetPost = this.feed.find((entry) =>
                this.pendingStreamPostIDs.includes(get(entry, 'object.ID', '').toString())
            );
            const targetPostID = get(targetPost, 'object.ID', '').toString();
            if (!targetPostID) return;

            const refEl = this.$refs[`post${targetPostID}`];
            const postComponent = Array.isArray(refEl) ? refEl[0] : refEl;
            const postElement = postComponent?.$el || postComponent;
            if (!postElement?.getBoundingClientRect) return;
            this.pendingStreamPostIcon =
                postElement.getBoundingClientRect().top > window.innerHeight ? 'chevron-down' : 'chevron-up';
        },
        removePendingStreamPostID(postID: string | number = '') {
            const normalizedPostID = postID ? postID.toString() : '';
            if (!normalizedPostID) return;
            this.pendingStreamPostIDs = this.pendingStreamPostIDs.filter((id) => id !== normalizedPostID);
            this.$nextTick(() => this.updatePendingStreamPostIcon());
        },
        scrollToPendingStreamPost() {
            const targetPost = this.feed.find((entry) =>
                this.pendingStreamPostIDs.includes(get(entry, 'object.ID', '').toString())
            );
            const targetPostID = get(targetPost, 'object.ID');
            if (!targetPostID) {
                this.pendingStreamPostIDs = [];
                return;
            }

            this.$set(targetPost, 'wasUpdated', true);
            this.$nextTick(() => {
                const refEl = this.$refs[`post${targetPostID}`];
                const postComponent = Array.isArray(refEl) ? refEl[0] : refEl;
                const postElement = postComponent?.$el || postComponent;
                if (postElement?.scrollIntoView) postElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                this.removePendingStreamPostID(targetPostID);
            });
        },
        syncFeedOrder() {
            this.feed = this.feed
                .filter(Boolean)
                .sort(
                    (a, b) =>
                        Number(get(b, 'object.CreatedAt', get(b, 'object.Created', 0))) -
                        Number(get(a, 'object.CreatedAt', get(a, 'object.Created', 0)))
                )
                .filter(
                    (entry, index, entries) =>
                        index ===
                        entries.findIndex(
                            (candidate) =>
                                get(candidate, 'object.ID', '').toString() === get(entry, 'object.ID', '').toString()
                        )
                );
        },
        showNextPostSuggestion() {
            // Cycle through the existing suggestion set without changing nudge eligibility.
            this.postSuggestionIndex = (this.postSuggestionIndex + 1) % POST_SUGGESTION_TYPES.length;
        },
        updatePostCreationNudgingFlag() {
            const enabled = this.$unleash.isEnabled(POST_CREATION_NUDGING_FLAG);
            if (enabled === this.postCreationNudgingEnabled) return;

            this.postCreationNudgingEnabled = enabled;
            if (enabled) {
                this.getPostingHistory();
            } else {
                this.postingHistoryRequestID += 1;
                this.postingHistoryLoading = false;
                this.postingHistoryEntries = null;
            }
        },
        dismissPostNudge(event) {
            // Consume touch-generated pointer events before removing the guide above the composer input.
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }
            const userID = get(this, '$store.state.me.ID', null);
            if (!userID) return;

            this.$store.commit('SET_POST_CREATION_NUDGE_DISMISSED_AT', {
                userID,
                dismissedAt: Math.floor(Date.now() / 1000),
            });
            EventBus.$emit('INFO', {
                Message: this.$t('communityFeed.postNudge.dismissed'),
            });
        },
        ensureFocusPostInFeed() {
            if (!this.focusPostID || this.loading) return;

            const focusId = String(this.focusPostID);
            const inFeed = this.feed.some((post) => String(get(post, 'object.ID', '')) === focusId);
            const inPinned = this.pinnedPosts.some((post) => String(get(post, 'object.ID', '')) === focusId);

            if (inFeed || inPinned) {
                this.lastMissingFocusPostID = null;
                return;
            }

            if (this.lastMissingFocusPostID === focusId) return;
            this.lastMissingFocusPostID = focusId;

            this.feed = [];
            this.feedBank = [];
            this.feedNextPage = null;
            this.nextParams = null;
            this.getPinnedPosts();
            this.getFeed();
        },
        generateUniqueID(prefix) {
            return prefix ? uniqueId(prefix) : uniqueId();
        },
        async handlePostPinChanged(changedPost) {
            const changedPostId = get(changedPost, 'ID');
            const pinStatus = get(changedPost, 'PinStatus', 0);

            if (changedPostId) {
                // Keep the in-memory feed in sync so pin/unpin updates the visible lists immediately.
                this.feed.forEach((post, index) => {
                    if (get(post, 'object.ID') === changedPostId) {
                        this.$set(this.feed[index].object, 'PinStatus', pinStatus);
                    }
                });
            }

            const pinnedPostID = changedPostId && pinStatus === 1 ? String(changedPostId) : null;
            await this.getPinnedPosts(pinnedPostID);
        },

        addedPost(post = {}) {
            const postID = get(post, 'object.ID', '').toString();
            const existingIndex = this.feed.findIndex((entry) => get(entry, 'object.ID', '').toString() === postID);

            // The app realtime stream can deliver the post before the editor emits its create result.
            if (postID && existingIndex > -1) {
                this.feed.splice(existingIndex, 1, post);
                this.syncFeedOrder();
                return;
            }

            this.feedBank = this.feedBank.filter((entry) => get(entry, 'object.ID', '').toString() !== postID);
            if (this.feed && this.feed.length > 0) {
                this.feed.unshift(post);
            } else {
                // celebrate the first post with some confetti :)
                jsConfetti.addConfetti();
                this.feed = [post];
            }
            // A newly created post makes the current user immediately ineligible for the composer nudge.
            this.postingHistoryRequestID += 1;
            this.postingHistoryLoading = false;
            this.postingHistoryEntries = [
                {
                    type: 'post',
                    object: {
                        CreatedAt: get(post, 'object.CreatedAt', Math.floor(Date.now() / 1000)),
                    },
                },
            ];
            this.postToEdit = null;
        },
        async getPostingHistory() {
            if (!this.postCreationNudgingEnabled) return;

            const userID = get(this, '$store.state.me.ID', null);
            if (!userID) {
                this.postingHistoryRequestID += 1;
                this.postingHistoryLoading = false;
                this.postingHistoryEntries = null;
                return;
            }

            // Only the latest request may update eligibility when the active user or flag changes.
            this.postingHistoryRequestID += 1;
            const requestID = this.postingHistoryRequestID;
            this.postingHistoryLoading = true;
            this.postingHistoryEntries = null;

            try {
                // Reuse the profile feed as the established source for authored post history.
                const response = await axios.get(`/user/profile/feed/${userID}`, {
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                const historyEntries = get(response, 'data.objects', null);
                if (!Array.isArray(historyEntries)) {
                    throw new Error('Invalid posting-history response');
                }
                if (requestID !== this.postingHistoryRequestID) return;
                this.postingHistoryEntries = historyEntries;
            } catch {
                if (requestID === this.postingHistoryRequestID) {
                    this.postingHistoryEntries = null;
                }
            } finally {
                if (requestID === this.postingHistoryRequestID) {
                    this.postingHistoryLoading = false;
                }
            }
        },
        getRouteFocusPostID() {
            const focusPostID = (
                get(this, '$route.query.focuspostid', '') ||
                get(this, '$route.query.postpin', '') ||
                ''
            ).toString();

            // Consume the URL hints without triggering route watchers or clearing the post highlight.
            const url = new URL(window.location.href);
            if (url.searchParams.has('focuspostid') || url.searchParams.has('postpin')) {
                url.searchParams.delete('focuspostid');
                url.searchParams.delete('postpin');
                window.history.replaceState(window.history.state, '', url.toString());
            }

            return focusPostID;
        },

        editedPost(post = {}) {
            if (post && this.feed) {
                const updatedPost = {
                    ...post,
                    wasUpdated: true,
                };
                // find the post in the feed by id and update it
                const index = this.feed.findIndex((p) => get(p, 'object.ID') === get(updatedPost, 'object.ID'));
                if (index > -1) {
                    this.feed.splice(index, 1, updatedPost);
                }
            }
            this.postToEdit = null;
        },

        editPost(post: Object = null) {
            if (!post) return;
            // map post structure to editor structure
            const postToEdit = {
                ...get(post, 'object', {}),
                Files: get(post, 'object.Images', []).map((image) => ({ url: image.ImageURL })),
                wasUpdated: true,
            };
            this.$refs.posteditor?.show(postToEdit, true);
        },
        scrollRefIntoView(ref) {
            const el = get(this, `$refs[${ref}][0]`, {});
            if (el.$el) el.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        },
        focusPinnedPost(ref) {
            this.$nextTick(() => {
                const target = get(this, `$refs[${ref}][0]`, null);
                const el = target && target.$el ? target.$el : null;

                if (!el) return;

                el.setAttribute('tabindex', '-1');
                try {
                    el.focus({ preventScroll: true });
                } catch (error) {
                    el.focus();
                }
                el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            });
        },
        async getPinnedPosts(pinnedPostID = null) {
            try {
                const response = await axios.get('/post/pin/list');
                const fetchedPinnedPosts = response.data.objects || [];
                // return if no pinned posts
                if (fetchedPinnedPosts.length < 1) {
                    this.pinnedPosts = [];
                    return;
                }
                const fetchUsers = fetchedPinnedPosts.map((entry) => entry.object.AuthorID);
                // fetch and populate post author info
                let users = null;
                try {
                    users = await axios.post('/user/listbyids', {
                        IDS: map(uniq(fetchUsers), (id) => ({ ID: id })),
                    });
                    users = map(users.data.Users, (user) => ({
                        ID: get(user, 'ID'),
                        Name: get(user, 'Profile.Name'),
                        Slug: get(user, 'Slug'),
                        ImageURL: get(user, 'Profile.ImageURL'),
                        Bio: get(user, 'Profile.Bio'),
                    }));
                    // map post object to co-post structure
                    fetchedPinnedPosts.forEach((entry) => {
                        // assign author infos
                        if (entry.object?.AuthorID) {
                            const author = users.find((user) => user.ID === entry.object.AuthorID);
                            entry.object.Author = author || {};
                        }
                        // assign space infos
                        entry.space ? (entry.object.Space = entry.space) : null;
                        // assign images for posts and page-updates (project-updates)
                        const tmpimages = get(entry, 'object.Images', null) || get(entry, 'object.ImageURLs', []);
                        entry.object.Images = map(tmpimages, (i) => ({ ImageURL: i }));
                    });
                    // display the pinned posts
                    // Mark the freshly pinned post as updated so CoPost reuses its existing highlight animation.
                    if (pinnedPostID) {
                        fetchedPinnedPosts.forEach((post) => {
                            post.wasUpdated = String(get(post, 'object.ID', '')) === pinnedPostID;
                        });
                    }
                    this.pinnedPosts = fetchedPinnedPosts;
                    if (pinnedPostID) {
                        const pinnedPost = fetchedPinnedPosts.find(
                            (post) => String(get(post, 'object.ID', '')) === pinnedPostID
                        );

                        if (pinnedPost) {
                            // Focus the freshly pinned card after it moves into the pinned section.
                            this.focusPinnedPost(`postpin${pinnedPostID}`);
                        }
                    }
                    // update the pinned status of the post in the feed if it exists in the feed
                    if (this.feed && this.feed.length > 0) {
                        const pinnedPostIds = new Set(this.pinnedPosts.map((pinnedPost) => pinnedPost.object.ID));
                        this.feed.forEach((post, index) => {
                            if (pinnedPostIds.has(post.object.ID)) {
                                this.$set(this.feed[index].object, 'PinStatus', 1);
                            } else {
                                this.$set(this.feed[index].object, 'PinStatus', 0);
                            }
                        });
                    }
                } catch (error) {
                    console.log(error);
                }
            } catch (error) {
                console.log(error);
            }
        },
        normalizeFeedEntry(entry, users = []) {
            if (!entry.object) return;

            const authorID = entry.object.AuthorID || entry.object.CreatedBy || entry.object.UserID;
            if (!entry.object.Author && authorID) {
                entry.object.Author = users.find((user) => user.ID === authorID);
            }
            if (entry.space) entry.object.Space = entry.space;

            const images = get(entry, 'object.Images', null) || get(entry, 'object.ImageURLs', []);
            entry.object.Images = map(images, (image) => (image?.ImageURL ? image : { ImageURL: image?.url || image }));
            entry.object.Type = entry.type;

            if (entry.type === 'post' && entry.object.ParentType !== 1 && entry.object.ParentType !== 2) return;

            // Parent-backed items use the same preview structure whether loaded initially or received live.
            if (!entry.object.Text) entry.object.Text = null;
            entry.object.ParentContent = {
                ...entry.object,
                Type: entry.type,
            };

            if (entry.object.ParentType === 1) {
                entry.object.ParentContent.Type = 'event';
            } else if (entry.object.ParentType === 2) {
                entry.object.ParentContent.Type = 'page-update';
            }

            switch (entry.object.ParentContent.Type) {
                case 'job':
                case 'event':
                case 'market-item':
                    break;
                case 'page':
                case 'project':
                    entry.object.ParentContent.Images = isArray(entry.object.ParentContent.ImageURL)
                        ? map(entry.object.ImageURL, (image) => {
                              if (typeof image === 'string' && image.match('/img/Platform_Gradients')) return false;
                              return { ImageURL: image };
                          })
                        : null;
                    entry.object.CreatedAt = entry.object.Created;
                    break;
                case 'page-update':
                    entry.object.ParentContent.Fetch = {
                        ID: entry.object.ParentID,
                        Type: 'project',
                    };
                    break;
                case 'project-update':
                    entry.object.ParentContent.Fetch = {
                        ID: entry.object.ProjectID,
                        Type: 'project',
                    };
                    entry.object.CreatedAt = entry.object.Created;
                    break;
            }
        },
        getFeed() {
            this.loading = true;

            const data = {
                Params: this.nextParams,
            };
            axios({
                method: 'POST',
                url: '/dashboard/feed/tmp',
                withCredentials: true,
                data,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(async (response) => {
                    if (get(response, 'data.Objects', []).length > 0) {
                        let posts = response.data.Objects;

                        // filter out the jobs if the market is disabled
                        if (!this.isMarketOn) {
                            posts = posts.filter((item) => item.type !== 'job');
                        }
                        // map content to post object structure
                        const fetchUsers = [];
                        posts.forEach((entry) => {
                            // skip if entry.object does not exist
                            if (!entry.object) return;

                            this.feedBank.push(entry);
                            if (entry.object.AuthorID || entry.object.CreatedBy || entry.object.UserID) {
                                fetchUsers.push(entry.object.AuthorID || entry.object.CreatedBy || entry.object.UserID);
                            }
                        }, this);
                        // fetch and populate post author info
                        let users = null;
                        try {
                            users = await axios({
                                method: 'POST',
                                url: '/user/listbyids',
                                data: { IDS: map(uniq(fetchUsers), (id) => ({ ID: id })) },
                                withCredentials: true,
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                            });
                            users = map(users.data.Users, (user) => ({
                                ID: get(user, 'ID'),
                                Name: get(user, 'Profile.Name'),
                                Slug: get(user, 'Slug'),
                                ImageURL: get(user, 'Profile.ImageURL'),
                                Bio: get(user, 'Profile.Bio'),
                            }));
                        } catch (error) {
                            console.log(error);
                        }
                        // Use one normalization path for paginated and live feed entries.
                        this.feedBank.forEach((entry) => this.normalizeFeedEntry(entry, users || []));
                        this.feedBank.sort((a, b) => a.object.Score - b.object.Score);
                        if (this.feedBank.length > 10) {
                            this.feed.push(...this.feedBank.slice(0, 10));
                            this.feedBank = this.feedBank.slice(10);
                        } else {
                            this.feed.push(...this.feedBank);
                            this.feedBank = [];
                        }
                    }

                    if (get(response, 'data.NextParams', null)) {
                        this.nextParams = response.data.NextParams;
                    } else {
                        this.nextParams = null;
                    }
                })
                .catch((error) => {
                    console.log(error);
                    // todo show error
                })
                .finally(() => {
                    this.loading = false;
                    this.ensureFocusPostInFeed();
                });
        },
        scroll() {
            window.onscroll = () => {
                const feedContainer = this.$refs['feed-container'];
                if (!feedContainer) return;

                // get the distance from the bottom of the page to the bottom of the feed container
                const distanceFromBottom = feedContainer.getBoundingClientRect().bottom - window.innerHeight;

                const percentage = (distanceFromBottom * 100) / feedContainer.clientHeight;

                if (percentage < 10) {
                    if (this.feedBank.length !== 0 && this.feedBank.length > 10) {
                        this.feed.push(...this.feedBank.slice(0, 10));
                        this.feedBank = this.feedBank.slice(10);
                    } else if (this.feedBank.length !== 0 && this.feedBank.length <= 10) {
                        this.feed.push(...this.feedBank);
                        this.feedBank = [];
                    } else if (
                        this.feedBank.length === 0 &&
                        (this.feedNextPage != null || this.nextParams != null) &&
                        !this.loading
                    ) {
                        this.getFeed();
                    }
                }
            };
        },
        handleUpgradeClick() {
            this.$router.push('/admin/account');
        },
    },
};
